import React from "react";
import { HeaderPage } from "./HeaderPage";
import { Typography } from "@mui/material";
import { PortfolioButtons } from "./PortfolioButtons";
import { Pmenu } from "./Pmenu";
import { convertImagePathToUrl } from "../../utils";

const formatModalDescription = (description) =>
  description?.replace(/(\r\n|\r|\n)/g, "<br>");

export const Introduction = ({ hero, about, details }) => {
  if (hero.length === 0) {
    return;
  }

  const buttonsFromJson = hero.details?.flatMap(
    (detail) =>
      detail.buttons?.map((button) => ({
        id: button.button_id,
        title: button.label,
        action: button.action,
        position: button.button_position,
      })) || []
  );
  return (
    <>
      {/* Hero */}
      <div id="hero" className="z-0 portfolioImg1">
        <div
          className="hidden lg:block sm:mt-0z"
          style={{ position: "", top: 0, zIndex: 50 }}
        >
          <HeaderPage />
        </div>
        <div className="lg:hidden">
          <Pmenu />
        </div>
        <div
          className="flex flex-col-reverse items-center px-4 py-20 justify-center mx-auto max-w-8xl text-white 2xl:flex-row"
          style={{ maxWidth: "1600px" }}
        >
          <div className="w-full 2xl:w-3/5 mt-2 lg:mt-0 min-w-0">
            <Typography
              className="font-bold"
              style={{
                fontSize: 48,
                fontFamily: "Montserrat",
              }}
            >
              {hero?.section_heading}
            </Typography>
            <Typography
              className="text-xl sm:text-3xl"
              style={{
                fontWeight: 600,
                fontFamily: "Montserrat",
              }}
            >
              {hero?.section_description}
            </Typography>
            {hero?.details.map((detail, index) => (
              <>
                {detail?.singleArray?.map((det, ind) => (
                  <React.Fragment key={ind}>
                    {det?.key === "sub-heading" && (
                      <>
                        <Typography
                          className="mt-5"
                          style={{
                            fontSize: 25,
                            fontFamily: "Montserrat",
                          }}
                        >
                          {det?.sub_heading}
                        </Typography>
                        <Typography
                          className="mx-auto my-5"
                          style={{
                            fontSize: 16,
                            fontWeight: 400,
                            fontFamily: "Montserrat",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: formatModalDescription(
                              det?.sub_heading_desc
                            ),
                          }}
                        />
                      </>
                    )}
                  </React.Fragment>
                ))}
              </>
            ))}
            <div className="mb-10">
              <PortfolioButtons Pbutton1={buttonsFromJson} />
            </div>
          </div>

          <div className="flex items-center justify-center w-full 2xl:w-2/5 min-w-0">
            {/* <img src={PImg1} /> */}

            {hero?.details?.map((detail, index) => (
              <React.Fragment key={index}>
                {detail?.assets?.map((asset, assetIndex) => (
                  <div key={assetIndex}>
                    {asset?.images?.map((img, imgIndex) => (
                      <img
                        key={imgIndex}
                        src={convertImagePathToUrl(img.image_url)}
                        className="w-full"
                        alt=""
                      />
                    ))}
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
      {/* About */}
      <div
        id="About"
        className="z-0 flex flex-row bg-cover bg-center portfolioImg2 py-10 sm:py-12  md:py-16"
      >
        <div
          className="flex flex-col lg:flex-row justify-center mx-auto"
          style={{ maxWidth: "1400px" }}
        >
          <div className="hidden xl:w-1/2 xl:flex items-center">
            {about?.details?.map((detail, index) => (
              <React.Fragment key={index}>
                {detail?.assets?.map((asset, assetIndex) => (
                  <div key={assetIndex}>
                    {asset?.images?.map((img, imgIndex) => (
                      <img
                        key={imgIndex}
                        src={convertImagePathToUrl(img.image_url)}
                        // className="w-[480px]"
                        className="object-cover"
                        alt=""
                      />
                    ))}
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>

          <div className="text-white xl:w-1/2 flex flex-col justify-center ">
            <Typography
              className="font-bold"
              style={{
                fontFamily: "Montserrat",
              }}
            >
              {about?.section_heading}
            </Typography>
            {about?.details?.map((detail) =>
              detail.sub_headings?.map((heading) => (
                <div key={heading.sub_heading_id} className="mb-10">
                  <Typography
                    className="mt-3 text-4xl font-bold"
                    style={{
                      fontFamily: "Montserrat",
                    }}
                  >
                    {heading.sub_heading}
                  </Typography>
                  {/* Image for mobile view (hidden on lg screens) */}
                  {detail?.assets?.map((asset, assetIndex) => (
                    <div
                      key={assetIndex}
                      className="lg:hidden flex justify-center my-4"
                    >
                      {asset?.images?.map((img, imgIndex) => (
                        <img
                          key={imgIndex}
                          src={convertImagePathToUrl(img.image_url)}
                          className="object-cover w-full max-w-[480px]"
                          alt=""
                        />
                      ))}
                    </div>
                  ))}
                  <Typography
                    className="my-10 text-sm 2xl:text-base "
                    style={{
                      fontWeight: 500,
                      fontFamily: "Montserrat",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: formatModalDescription(heading.sub_heading_desc), // Correctly using dangerouslySetInnerHTML here
                    }}
                  />
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};
